import React from "react";
import { Route, Routes as Rts } from "react-router-dom";
import { ProtectedRoute } from "../router/ProtectedRoute";
import Dashboard from "../features/dashboard";
import Transaction from "../features/transaction/screens/Transaction";
import Account from "../features/home/screens/Account";
import { HeaderLayout } from "../router/HeaderLayout";
import { Maintainance } from "../features/core/components/Maintainance";
import { useTheme } from "../theme/ThemeProvider";

const screensWithoutHeader = ["/dashboard/home/account"];
const HomeLayout = () => {
  const { theme } = useTheme();
  return (
    <div>
      <Rts>
        <Route
          element={<HeaderLayout screensWithoutHeader={screensWithoutHeader} />}
        >
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transaction/*"
            element={
              <ProtectedRoute>
                <Transaction />
              </ProtectedRoute>
            }
          />
          <Route path="/notifications" element={<Maintainance />} />
          <Route path="/analytics" element={<Maintainance />} />
          <Route path="/home/account/:account" element={<Account />} />
          {theme === "aub" && (
            <>
              {" "}
              <Route path="/loans" element={<Maintainance />} />
              <Route path="/cards" element={<Maintainance />} />
              <Route path="/reports" element={<Maintainance />} />
              <Route path="/service-requests" element={<Maintainance />} />
            </>
          )}{" "}
        </Route>
      </Rts>
    </div>
  );
};

export default HomeLayout;
